import { ModalProps } from 'antd';
import { StyledModal } from './index.styles';

export interface IModalProps extends ModalProps {}

export function Modal(props: IModalProps) {
  return <StyledModal {...props} />;
}
